import script from "./AuditLog.vue?vue&type=script&setup=true&lang=js"
export * from "./AuditLog.vue?vue&type=script&setup=true&lang=js"

import "./AuditLog.vue?vue&type=style&index=0&id=291d767a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-291d767a"]])

export default __exports__